import { render, staticRenderFns } from "./Catalogues.vue?vue&type=template&id=3ba7a066&scoped=true"
import script from "./Catalogues.vue?vue&type=script&lang=js"
export * from "./Catalogues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7a066",
  null
  
)

export default component.exports